/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import { connectRequests } from '../../../higherOrderComponents/requests';

export default connectRequests((state, props) => {
  const { instanceKey, queryParam }  = props;
  let incidentStatusUrl = instanceKey
  ? `/instances/${props.instanceKey}/status`
  : `/instanceAliases/${props.aliasKey}/status`;
  const type = queryParam.length > 0 ? queryParam.split('?type=')[1] : '';
  if (type && !instanceKey) incidentStatusUrl += `?type=${type}`;
  return ({
    incidentStatus: {
      url: incidentStatusUrl,
      onLoad: true,
    }
  });
});
